/**
 * SystemDiagnosticsPanel — the 'system' area: live status surfaces and
 * destructive actions, not configuration. See areas.ts 'system'.
 */
import { SyncStatusSection } from '../sections/SyncStatusSection';
import { SentryStatusSection } from '../sections/SentryStatusSection';
import { DevToolsSection } from '../sections/DevToolsSection';
import { ResetSection } from '../sections/ResetSection';

export function SystemDiagnosticsPanel() {
  return (
    <>
      <SyncStatusSection />
      <SentryStatusSection />
      <DevToolsSection />
      <ResetSection />
    </>
  );
}
